function htmlToElement(html) {
  let temp = document.createElement("template");
  temp.innerHTML = html;
  return temp.content.firstChild;
}

export default htmlToElement;
